<template>
  <svg class="tm-tab-icon" viewBox="0 0 24 24" width="18" height="18" fill="none"
       stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <!-- vorschau: Zeitung -->
    <template v-if="name === 'vorschau'">
      <path d="M4 5h13v14H6a2 2 0 0 1-2-2V5z"/><path d="M17 9h3v8a2 2 0 0 1-2 2h-1"/><path d="M7 9h7M7 13h7M7 16h4"/>
    </template>
    <!-- spielbericht: Dokument mit Stift -->
    <template v-else-if="name === 'spielbericht'">
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/>
    </template>
    <!-- aufstellung: Trikot -->
    <template v-else-if="name === 'aufstellung'">
      <path d="M8 4 3 7l2 4 3-1v10h8V10l3 1 2-4-5-3a4 4 0 0 1-8 0z"/>
    </template>
    <!-- events: Ball -->
    <template v-else-if="name === 'events'">
      <circle cx="12" cy="12" r="9"/><path d="m12 8 3.5 2.5-1.3 4h-4.4l-1.3-4z"/><path d="M12 3v5M15.5 10.5 20 9M14.2 14.5l2.6 3.6M9.8 14.5l-2.6 3.6M8.5 10.5 4 9"/>
    </template>
    <!-- wechsel: Pfeile -->
    <template v-else-if="name === 'wechsel'">
      <path d="M4 8h13l-3-3M20 16H7l3 3"/>
    </template>
    <!-- statistik: Balken -->
    <template v-else-if="name === 'statistik'">
      <path d="M5 20V11M12 20V4M19 20v-6"/>
    </template>
    <!-- ausfaelle: Pflaster -->
    <template v-else-if="name === 'ausfaelle'">
      <rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-45 12 12)"/><path d="M10.5 10.5l3 3"/>
    </template>
    <!-- fakten: Glühbirne -->
    <template v-else-if="name === 'fakten'">
      <path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"/>
    </template>
    <!-- h2h: zwei Pfeile gegeneinander -->
    <template v-else-if="name === 'h2h'">
      <path d="M3 8h12l-3-3M21 16H9l3 3"/><path d="M15 8h6M3 16h6" opacity=".45"/>
    </template>
    <!-- tabelle: Liste -->
    <template v-else-if="name === 'tabelle'">
      <rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M3 14h18M9 9v11"/>
    </template>
    <!-- spiele: Kalender -->
    <template v-else-if="name === 'spiele'">
      <rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>
    </template>
  </svg>
</template>

<script setup>
defineProps({ name: { type: String, required: true } })
</script>